import type { Messages } from "../types";

export const messages: Messages = {
  shared: {
    title: "Compte client Fielmann",
    tabs: {
      login: "Connexion",
      signup: "S’inscrire",
      ariaLabel: "Authentification",
    },
    languageSwitcher: {
      label: "Choisir la langue",
    },
    password: {
      show: "Afficher le mot de passe",
      hide: "Masquer le mot de passe",
    },
    header: {
      logoAriaLabel: "Fielmann",
    },
    footer: {
      ariaLabel: "Pied de page",
      customerService: "Service clientèle",
      legalNotice: "Mentions légales",
      dataProtection: "Protection des données",
    },
    loading: {
      ariaLabel: "Un instant, s’il te plaît...",
      content: "Chargement des contenus.",
    },
  },
  login: {
    subtitle: "Connecte-toi avec ton e-mail et ton mot de passe.",
    form: {
      emailLabel: "E-mail *",
      passwordLabel: "Mot de passe *",
      forgotPassword: "Mot de passe oublié ?",
      submitButton: "Se connecter",
      credentialError: "L’e-mail et le mot de passe ne correspondent pas.",
      genericError: "Une erreur s’est produite. Réessaie plus tard.",
    },
  },
  signup: {
    subtitle: {
      before: "Profite des ",
      highlight: "avantages",
      after: " et crée ton compte client Fielmann.",
    },
    benefits: {
      popoverHeading: "Tes avantages :",
      closeLabel: "Fermer",
      items: {
        orders:
          "Toutes les commandes Fielmann, y compris leur statut, en un coup d’œil.",
        visionValues:
          "Réutilise tes valeurs oculaires pour ta prochaine commande.",
        appointments: "Prends et gère tes rendez-vous.",
        reorders: "Repasse facilement commande en ligne.",
      },
    },
    form: {
      firstNameLabel: "Prénom *",
      lastNameLabel: "Nom de famille *",
      emailLabel: "E-mail *",
      passwordLabel: "Mot de passe *",
      passwordRepeatLabel: "Confirmer le mot de passe *",
      submitButton: "S’inscrire",
      errorTitle: "Le compte n’a pas pu être créé.",
      errorMessage: "Vérifie tes informations ou réessaie plus tard.",
      genericError: "Une erreur s’est produite. Réessaie plus tard.",
    },
    consents: {
      requiredError: "Merci de donner le consentement requis.",
      unavailableError: "Une erreur s’est produite. Réessaie plus tard.",
      required: {
        headline: "Consentement au compte client",
        subline:
          "Pour que nous puissions afficher tous les contenus dans ton compte client (par ex. achats ou rendez-vous), nous avons besoin de ton consentement.",
      },
      optional: {
        headline: "Souhaites-tu recevoir de la publicité personnalisée ?",
        subline:
          "Tu as le choix : avec ton consentement, tu reçois des offres et des informations adaptées à tes besoins. Sans consentement, tu utilises ton compte client sans publicité personnalisée.",
      },
    },
  },
  emailVerification: {
    subtitle: "Tu ne peux pas te connecter ?",
    alertTitle: "Confirme d’abord ton adresse e-mail.",
    alertBody:
      "Merci de confirmer d’abord ton adresse e-mail afin d’activer ton compte Fielmann.",
    alertSpamHint:
      "Tu ne trouves pas l’e-mail ? Vérifie aussi ton dossier spam.",
    resendButton: "Renvoyer l’e-mail",
    backToLogin: "Retour à la connexion",
  },
  setPassword: {
    subtitle: "Tu peux maintenant définir ton mot de passe.",
    emailLabel: "E-mail *",
    passwordLabel: "Mot de passe *",
    passwordRepeatLabel: "Confirmer le mot de passe *",
    submitButton: "Enregistrer le mot de passe",
    backToLogin: "Aller à la connexion",
    successTitle: "Ton mot de passe a été enregistré avec succès.",
    successBody: "Tu peux maintenant te connecter.",
  },
  toasts: {
    missingRequiredFields:
      "Remplis tous les champs obligatoires encore manquants pour continuer.",
  },
  validation: {
    passwordRequired: "Saisis un mot de passe.",
    passwordRepeatRequired: "Saisis à nouveau le mot de passe.",
    firstNameTooLong: "Le prénom ne doit pas dépasser 30 caractères.",
    firstNameRequired: "Saisis un prénom.",
    firstNameInvalidFormat: "Saisis un prénom valide.",
    lastNameTooLong: "Le nom de famille ne doit pas dépasser 30 caractères.",
    lastNameRequired: "Saisis un nom de famille.",
    lastNameInvalidFormat: "Saisis un nom de famille valide.",
    emailTooLong: "L’adresse e-mail est trop longue.",
    emailRequired: "Saisis une adresse e-mail.",
    emailInvalidFormat: "Saisis une adresse e-mail valide.",
    passwordMatchesEmail:
      "Le mot de passe ne doit pas être identique à l’adresse e-mail.",
    passwordMismatch: "Les mots de passe ne correspondent pas.",
  },
  passwordRequirements: {
    minimumLength: "Au moins 10 caractères",
    mixedCase: "Au moins une majuscule et une minuscule",
    hasNumber: "Au moins un chiffre",
    specialCharactersAllowed:
      "Les caractères spéciaux sont autorisés (p. ex. !@#$%^&*)",
  },
};
